/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  $('[data-carousel]').each((i, container) => {
    createSwiper(container)
  })
}

function loadSwiper() {
  return import(/* webpackChunkName: "Swiper" */ 'swiper/dist/js/swiper.js')
}

function getColumnsFromClass(className, fallback = 1) {
  const results = container.className.match(/columns-(\d+)(-(\d+))?/)
  if (!results) return fallback
  if (!results[3]) return parseInt(results[1])
  return parseInt(results[3])
}

function createSwiper(container) {
  loadSwiper().then(({ default: Swiper }) => {
    const config = $(container).data('carousel')
    const swiper = new Swiper(container, {
      slidesPerView: 'auto',
      loop: config.loop === null ? false : config.loop,
      centeredSlides: config.centeredSlides === null ? false : config.centeredSlides,
      navigation: {
        nextEl: '[data-button-next]',
        prevEl: '[data-button-prev]',
      },
    })

    swiper.on('slideChange', updateNavigationIndicator)

    function updateNavigationIndicator() {
      const x = swiper.activeIndex * 100
      $('[data-swiper-navigation-indicator]', container).css({ transform: `translateX(${x}%)` })
    }
  })
}
